import axios from 'axios';
import api from '@/lib/axios';
import { createDocumentLifecycleApi } from './documentLifecycleRequests.js';

// Dedicated client: do not attach the general API's automatic retry handlers.
// Browser cookies and server-resolved tenant context remain authoritative.
const client = axios.create({
  baseURL: api.defaults.baseURL,
  withCredentials: true,
  timeout: 120000,
  headers: { Accept: 'application/json' },
});
export const documentLifecycleApi = createDocumentLifecycleApi(client);
